@if ((layers$ | async).length) {
  <igo-layer-viewer
    class="mapDetailsList"
    [map]="map"
    [options]="layerViewerOptions"
    [excludeBaseLayers]="excludeBaseLayers"
    [isDesktop]="isDesktop"
  >
    <ng-template #customBottomActions let-layer="layer">
      <igo-workspace-button [layer]="layer" />
      <igo-export-button [layer]="layer" (click)="activateExport(layer)" />
      <igo-ogc-filter-button [header]="ogcButton()" [layer]="layer" />
      <igo-time-filter-button [header]="timeButton()" [layer]="layer" />
      <igo-track-feature-button [trackFeature]="true" [layer]="layer" />
      <igo-metadata-button [layer]="layer" />
    </ng-template>
  </igo-layer-viewer>
} @else {
  @if (delayedShowEmptyMapContent) {
    <mat-list>
      <p class="map-empty">
        {{ 'igo.integration.mapTool.empty' | translate }}
      </p>
      @if (
        layerAdditionAllowed() &&
        (searchToolInToolbar || catalogToolInToolbar || contextToolInToolbar)
      ) {
        <p class="map-empty">
          {{ 'igo.integration.mapTool.customize' | translate }}
        </p>
      }
      @if (layerAdditionAllowed() && searchToolInToolbar) {
        <mat-list-item>
          <mat-icon matListItemIcon>search</mat-icon>
          <span matListItemTitle class="search-tool" (click)="searchEmit()">
            {{ 'igo.integration.mapTool.search-tool' | translate }}
          </span>
        </mat-list-item>
      }
      @if (layerAdditionAllowed() && catalogToolInToolbar) {
        <mat-list-item>
          <mat-icon matListItemIcon>library_add</mat-icon>
          <span matListItemTitle class="catalog-tool" (click)="catalogEmit()">
            {{ 'igo.integration.mapTool.catalog-tool' | translate }}
          </span>
        </mat-list-item>
      }
      @if (layerAdditionAllowed() && contextToolInToolbar) {
        <mat-list-item>
          <mat-icon matListItemIcon>star</mat-icon>
          <span matListItemTitle class="context-tool" (click)="contextEmit()">
            {{ 'igo.integration.mapTool.context-tool' | translate }}
          </span>
        </mat-list-item>
      }
    </mat-list>
  }
}
